// ======================================================================
// FILE: src/modules/wms/dashboard/components/DashboardHeader.jsx
// MODULE: Work Management System (WMS)
// PURPOSE:
//   Dashboard Header
// ======================================================================

import React from "react";

export default function DashboardHeader({
  onRefresh,
  loading = false,
}) {

  return (

    <div
      className="card border-0 mb-4"
      style={{
        background: "linear-gradient(90deg,#0d6efd,#4f8cff)",
        borderRadius: "12px",
        color: "#fff",
      }}
    >

      <div
        className="
          card-body
          d-flex
          justify-content-between
          align-items-center
          flex-wrap
          gap-3
        "
      >

        {/* Left */}

        <div>

          <h2 className="mb-1">
            Work Management System Dashboard
          </h2>

          <div
            style={{
              opacity: 0.9,
            }}
          >
            Daily Operations Dashboard
          </div>

        </div>

        {/* Right */}

        <div
          className="
            d-flex
            align-items-center
            gap-2
            flex-wrap
          "
        >

          <button
            className="btn btn-light"
            type="button"
            onClick={onRefresh}
            disabled={loading}
          >
            <i
              className={
                loading
                  ? "fas fa-sync-alt fa-spin me-2"
                  : "fas fa-sync-alt me-2"
              }
            />
            {loading ? "Refreshing..." : "Refresh"}
          </button>

          <div
            className="text-white"
            style={{
              fontSize: "14px",
            }}
          >
            Last Updated:
            <br />
            Just Now
          </div>

        </div>

      </div>

    </div>

  );

}